export const collaboratorsLocale = {
   title: '合作者',
   code: "推荐code",
   link: "link",
   number_people_invited: "邀请用户数",
   level: "Level",
   balance_received: "未收到余额",
   register_withdraw: "注册取款",
   list_user_invite: '用户邀请列表',
   search: 'search',
   stt: '序号',
   time: '时间',
   mail: 'mail',
   kyc: 'kyc',
   withdrawal_history: '取款历史',
   amount: '数量',
   token_type: 'Token 类型',
   status: '状态',
   register_title: '注册成为合作者',
   register_content: '通过点击下面的确认按钮，您将同意参与 AIS 合作者计划。',
   confirm_register: '确认',
   close_register: '取消',
   withdraw_all: '全额取钱',
   withdraw_landmark: '按里程碑取钱',
   money: '金额',
   money_remaining: '剩余',
   withdrawal_fee: '取钱的费用',
   bonus_draw_milestone: '奖金提款里程碑（推荐人） ',
   withdraw_content: '用户可以选择根据当前等级或全额取钱。 取钱时，等级和推荐数量将被重置。 全额提款将收取 2000 STN-A 的费用。',
   unknown_error: '发生了一个错误。请稍后重试。',
   oops: '不好意思!',
   ok: 'OK',
};
